define(function (require) {
    "use strict";

	var LE = require("app");
    var LEResourceResolver = require("leResourceResolver");
    var ContentRouteController = require("content-controllers/ContentRouteController");
    var ContentDataManager = require("content-controllers/ContentDataManager");
    var ContentModuleLayout = require("content-views/ContentModuleLayout");
    var ContentContextController = require("content-controllers/ContentContextController");
    var CONST = require("const");

    return LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {
        var dataManager,moduleLayout;

        (function() {
            // Expose canned edit screen open
            LEContent.channel.comply(LE.mediaCodes.content.commands.cannedEdit, function() {
                if (LE.siteSettings.contentSettings.getCannedResponsesSource() === CONST.SOURCE_ENUM.LEGACY) {
                    cannedAnswersOpenWindowConfig.targetWindow = LEContent.router.open(cannedAnswersOpenWindowConfig.cannedAnswersUrl, cannedAnswersOpenWindowConfig.targetWindowName);
                }
                else {
                    LEContent.router.navigate("content/canned");
                }
            });

            // Expose system edit screen open
            LEContent.channel.comply(LE.mediaCodes.content.commands.systemEdit, function() {
                if (LE.siteSettings.contentSettings.getSystemMessagesSource() === CONST.SOURCE_ENUM.LEGACY) {
                    systemMessagesOpenWindowConfig.targetWindow = LEContent.router.open(systemMessagesOpenWindowConfig.systemMessagesUrl, systemMessagesOpenWindowConfig.targetWindowName);
                }
                else {
                    LEContent.router.navigate("content/system");
                }
            });

            // Expose system messaging edit screen open
            LEContent.channel.comply(LE.mediaCodes.content.commands.systemMessagingEdit, function() {
                LEContent.router.navigate("content/systemMessaging");
            });

            // Expose window texts edit screen open
            LEContent.channel.comply(LE.mediaCodes.content.commands.windowTextsEdit, function() {
                if (LE.siteSettings.contentSettings.getSystemMessagesSource() === CONST.SOURCE_ENUM.LEGACY) {
                    windowTextsMessagesOpenWindowConfig.targetWindow = LEContent.router.open(windowTextsMessagesOpenWindowConfig.windowTextsMessagesUrl, windowTextsMessagesOpenWindowConfig.targetWindowName);
                }
                else {
                    LEContent.router.navigate("content/windowTexts");
                }
            });
        })();

        LEContent.addInitializer(function () {
            LEContent.context = new ContentContextController();
            initPrivileges();
            moduleLayout = new ContentModuleLayout();
            dataManager = new ContentDataManager({
                module:{
                    //name: "", // module name is not needed. adding it here will create a bug. no auto listen is needed. please see BaseDataManager documentation.
                    mainRegion: LEContent.getMainRegion(),
                    showLoader: LEContent.showLoader,
                    closeLoader: LEContent.closeLoader,
                    notifier: LEContent.notifier
                }
            });
            LEContent.routeController = new ContentRouteController();

            initCannedAnswersLegacyNavigation();
            initSystemMessagesLegacyNavigation();
            initWindowTextsMessagesLegacyNavigation();
        });
        var cannedAnswersOpenWindowConfig = null;
        var systemMessagesOpenWindowConfig = null;
        var windowTextsMessagesOpenWindowConfig = null;

        var initCannedAnswersLegacyNavigation = function () {
            cannedAnswersOpenWindowConfig = {
                targetWindow : null,
                targetWindowName : "_blank",
                cannedAnswersUrl :  LEResourceResolver.getUrl(LEResourceResolver.apiResources.AppServer.CannedAnswers)
            };
        };

        var initSystemMessagesLegacyNavigation = function () {
            systemMessagesOpenWindowConfig = {
                targetWindow : null,
                targetWindowName : "_blank",
                systemMessagesUrl :  LEResourceResolver.getUrl(LEResourceResolver.apiResources.AppServer.SystemMessages)
            };
        };

        var initWindowTextsMessagesLegacyNavigation = function () {
            windowTextsMessagesOpenWindowConfig = {
                targetWindow : null,
                targetWindowName : "_blank",
                windowTextsMessagesUrl :  LEResourceResolver.getUrl(LEResourceResolver.apiResources.AppServer.WindowTextsMessages)
            };
        };

        var initPrivileges = function () {
            LEContent.context.set(LEContent.context.KEYS.hasContentImportPrivileges, LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.CANNED_RESPONSES_IMPORT));

        };

        LEContent.getRouteController = function () {
            return LEContent.routeController;
        };

        LEContent.getMainView = function() {
            return moduleLayout;
        };

        LEContent.getMainRegion = function() {
            return LEContent.getMainView().mainRegion;
        };

        LEContent.getDataManager = function() {
            return dataManager;
        };

        LEContent.showLoader = function(options) {
            moduleLayout.showLoader(options);
        };

        LEContent.closeLoader = function() {
            moduleLayout.closeLoader();
        };
        LEContent.getContext = function () {
            return LEContent.context;
        };

        LEContent.lockReporting = true;
    });

});


